module.exports = __webpack_public_path__ + "img/arrow-right-icon.c1787b41.svg";